<div class="modal-content">
  <form (submit)="this.availabilityMutation.mutate($event)">
    <app-modal-content
      title="Currently you are not available"
      submitText="Set me as available"
      i18n-submitText
      [submitDisabled]="false"
      [submitLoading]="availabilityMutation.isPending()"
      i18n-title
    >
      <div class="modal-content__container">
        <div class="modal-content__description">
          <p i18n>
            New communications cannot be assigned because your current status is "Not available". To receive new
            assignments, you can change your status to available.
          </p>
        </div>
      </div>
    </app-modal-content>
  </form>
</div>
